import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_dw8nzvex52: FaireBrandEntity = {
  token: "b_dw8nzvex52",
  type: "brand",
  name: "Sonreír Coffee Company",
  avatarUrl:
    "https://cdn.faire.com/fastly/fe62836fcb016a5b0f3e091d719daeba6de61854f0a18b3c65f9b9efc8411b40.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/c3b1397953e5b5a7d17e3e70dcbe3671f847b2a3f46d205d0d204a9fac9b040f.png",
  logoUrl:
    "https://cdn.faire.com/fastly/fe62836fcb016a5b0f3e091d719daeba6de61854f0a18b3c65f9b9efc8411b40.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c3b1397953e5b5a7d17e3e70dcbe3671f847b2a3f46d205d0d204a9fac9b040f.png",
  location: "san francisco, CA, USA",
  minimumOrderDollars: 0,
  rating: 4.8,
  reviewCount: 13,
  isInsider: true,
  description:
    "Sonreír - “to smile” in Spanish - is a family-run modern Mexican coffee brand. We’re coffee first: specialty-grade, single-origin Mexican beans in our RTD Coffee cans. Coconut milk base, zero refined sugar, Non-GMO Project Verified, plant-based.\n\nWhy it earns the shelf space: the RTD set is wall-to-wall oat and dairy right now. A coconut milk base stands out, and a Latino-founded brand is a story your shoppers genuinely haven’t seen yet — which is the difference between a can that gets picked up and one that gets walked past. Four recipes from cafecito culture (Cold Brew, Vanilla Horchata, Dulce de Leche, Mocha Mexicano), a sleek 8oz can that merchandises clean, and a $4.99 MSRP that holds a healthy margin.\n\nOrder a case. Let’s see how it moves on your shelf.",
  meta: {
    source: "api",
    importedAt: "2026-07-31T16:23:51.593Z",
    importedBy: "entity-db-cli",
  },
};
